module.exports = __webpack_public_path__ + "445548d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/banner/splash-square.jpg
// module id = 2750
// module chunks = 15